<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import DurationInput from '@/components/input/DurationInput.vue'
import validationFormMixin from '@/mixins/validation.mixin'

export default {
  name: 'SensorVirtualPeriodoUltimasHoras',
  components: { DurationInput },
  mixins: [validationMixin, validationFormMixin],
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  validations: {
    form: {
      duracao: { required },
    },
  },
  data() {
    return {
      form: {
        duracao: '12:00',
      },
    }
  },
  watch: {
    form: {
      handler: 'onChange',
      deep: true,
    },
  },
  beforeMount() {
    if (this.data) {
      this.form.duracao = this.data.duracao || '12:00'
    }
  },
  mounted() {
    this.$emit('change', { ...this.form })
  },
  methods: {
    onChange() {
      this.$v.form.$touch()

      if (this.$v.form.$invalid) {
        this.$emit('change', null)
        return
      }

      this.$emit('change', { ...this.form })
    },
  },
}
</script>

<template>
  <div class="row">
    <DurationInput
      v-model="form.duracao"
      class="col-4"
      title="Duração"
      :validation-class="getValidationClass('duracao')"
    >
      <span v-if="!$v.form.duracao.required" class="md-error"
        >Horário inválido</span
      >
    </DurationInput>
  </div>
</template>

<style scoped lang="scss"></style>
